import styled from "styled-components";

export const CmpCarInfoChange = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const CmpItemTit = styled.div`
  font-size: 1.8rem;
`;

export const CmpCarInfoConentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 15px;
`;

export const CmpCarInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;

  .vehicleNumber {
    width: 100%;
    padding: 15px;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
  }
`;

export const CmpCarInfoCheckBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;

  p {
    font-size: 1.6rem;
  }
`;

export const CmpCarCheckDetail = styled.div`
  width: 100%;
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  gap: 6px;
  white-space: nowrap; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
`;

export const CmpButtonBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  bottom: 0;

  .small {
    width: 60%;
  }
`;
